<template>
  <WdsMenu z-index="50" placement="bottom-end" manual-trigger :global="global">
    <template #trigger="{ toggle }">
      <WdsButtonGhost :data-test="dataTest" :aria-label="$t('Client actions')" @click="toggle">
        <WdsIcon name="overflow-menu-horizontal" :size="16" />
      </WdsButtonGhost>
    </template>

    <WdsMenuOption :data-test="`${dataTest}-view-page`" @click="emit('view-page', $event)">
      <WdsIcon :size="16" name="maximize" />
      {{ $t('View client page') }}
    </WdsMenuOption>

    <WdsMenuOption
      v-if="canManageAgencies"
      :data-test="`${dataTest}-link-agency`"
      @click="emit('link-agency')"
    >
      <WdsIcon :size="16" name="add" />
      {{ hasLinkedAgencies ? $t('Manage staffing agencies') : $t('Link staffing agencies') }}
    </WdsMenuOption>

    <WdsMenuOption
      v-if="canManageOwners"
      :data-test="`${dataTest}-manage-owners`"
      @click="emit('manage-owners')"
    >
      <WdsIcon :size="16" name="add" />
      {{ $t('Manage owners') }}
    </WdsMenuOption>
  </WdsMenu>
</template>

<script lang="ts" setup>
import { WdsButtonGhost, WdsIcon, WdsMenu, WdsMenuOption } from '@worksome/wds-components'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

withDefaults(
  defineProps<{
    dataTest: string
    global?: boolean | string
    hasLinkedAgencies?: boolean
    canManageAgencies?: boolean
    canManageOwners?: boolean
  }>(),
  {
    global: false,
    hasLinkedAgencies: false,
    canManageAgencies: false,
    canManageOwners: false,
  },
)

const emit = defineEmits<{
  (e: 'view-page', event: MouseEvent | undefined): void
  (e: 'link-agency'): void
  (e: 'manage-owners'): void
}>()
</script>
